/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Draft_Reset_HintInputs */

const vi_einvoice_draft_reset_hint = /** @type {(inputs: Einvoice_Draft_Reset_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thao tác này bỏ các chỉnh sửa ngày, tên hàng, chiết khấu, VAT và các dòng đã xóa trên nháp, rồi lấy lại dữ liệu đơn hàng hiện tại. Thông tin người mua nhận hóa đơn vẫn giữ nguyên. Bạn cần kiểm tra PDF mới trước khi phát hành.`)
};

/**

* @param {Einvoice_Draft_Reset_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_draft_reset_hint = /** @type {((inputs?: Einvoice_Draft_Reset_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Draft_Reset_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_draft_reset_hint(inputs)
});